(function () {
    const stopOnFrames = [
        // time,   left,     top,    hint
        [0, 0, 1 - 0.05, "<span class='d-flex'><span class='step__number '>1</span><span class='d-flex flex-column'><span class='step__name'>Secondary Market</span><span class='step__dscr'>Investor places a buy order for units of the ETP</span></span></span>"],
        [1, 0, 1 - 0.05, "<span class='d-flex'><span class='step__number '>1</span><span class='d-flex flex-column'><span class='step__name'>Secondary Market</span><span class='step__dscr'>Investor places a buy order for units of the ETP</span></span></span>"],
        [105, 0, 1 - 0.05, "<span class='d-flex'><span class='step__number '>2</span><span class='d-flex flex-column'><span class='step__name'>Secondary Market</span><span class='step__dscr'>Broker uses existing inventory or buys ETP securities from AP for cash</span></span></span>"],
        [200, 0, 1 - 0.05, "<span class='d-flex'><span class='step__number orange'>3</span><span class='d-flex flex-column'><span class='step__name'>Primary Market</span><span class='step__dscr'>AP places an order with Issuer and transfers cryptocurrency to the custodian</span></span></span>"],
        [345, 0, 1 - 0.05, "<span class='d-flex'><span class='step__number orange'>3</span><span class='d-flex flex-column'><span class='step__name'>Primary Market</span><span class='step__dscr'>AP sources cryptocurrency or uses existing inventory for subscription with the Issuer</span></span></span>"],
        [470, 0, 1 - 0.05, "<span class='d-flex'><span class='step__number orange'>3</span><span class='d-flex flex-column'><span class='step__name'>Primary Market</span><span class='step__dscr'>The independent transaction administrator verifies the incoming order and confirms the required amounts and corresponding balances.</span></span></span>"],
        [550, 0, 1 - 0.05, "<span class='d-flex'><span class='step__number gray-blue'>4</span><span class='d-flex flex-column'><span class='step__name'>Primary Market</span><span class='step__dscr'>The independent transaction administrator verifies the incoming order and confirms the required amounts and corresponding balances. <br><br>Once both Issuer and Administrator have verified that cryptocurrency has settled in the custody account, the Issuer instructs the Depo Bank to send ETP securities to the AP</span></span></span>"],
        [710, 0, 1 - 0.05, "<span class='d-flex'><span class='step__number orange'>3</span><span class='d-flex flex-column'><span class='step__name'>Primary Market</span><span class='step__dscr'>AP sources cryptocurrency or uses existing inventory for subscription with the Issuer</span></span></span>"],
        [800, 0, 1 - 0.05, "<span class='d-flex'><span class='step__number gray-blue'>5</span><span class='d-flex flex-column'><span class='step__name'>Secondary Market</span><span class='step__dscr'>AP settles with broker and investor receives ETP securities</span></span></span>"],
    ];
    const stopOnFrames1 = [
        // time,   left,     top,    hint
        [0, 0, 1 - 0.05, "<span class='d-flex'><span class='step__number gray-blue'>1</span><span class='d-flex flex-column'><span class='step__name'>Secondary Market</span><span class='step__dscr'>Investor places sell order for ETP securities</span></span></span>"],
        [1, 0, 1 - 0.05, "<span class='d-flex'><span class='step__number gray-blue'>1</span><span class='d-flex flex-column'><span class='step__name'>Secondary Market</span><span class='step__dscr'>Investor places sell order for ETP securities</span></span></span>"],
        [110, 0, 1 - 0.05, "<span class='d-flex'><span class='step__number gray-blue'>2</span><span class='d-flex flex-column'><span class='step__name'>Secondary Market</span><span class='step__dscr'>Broker settles ETP securities with AP </span></span></span>"],
        [190, 0, 1 - 0.05, "<span class='d-flex'><span class='step__number gray-blue'>3</span><span class='d-flex flex-column'><span class='step__name'>Primary Market</span><span class='step__dscr'>AP delivers ETP securities to the Issuer’s account with the Depo Bank</span></span></span>"],
        [270, 0, 1 - 0.05, "<span class='d-flex'><span class='step__number gray-blue'>3</span><span class='d-flex flex-column'><span class='step__name'>Primary Market</span><span class='step__dscr'>Administrator needs to check and sign-off on every transaction<br><br>AP delivers ETP securities to the Issuer’s account with the Depo Bank</span></span></span>"],
        [405, 0, 1 - 0.05, "<span class='d-flex'><span class='step__number orange'>4</span><span class='d-flex flex-column'><span class='step__name'>Primary Market</span><span class='step__dscr'>Only after ETP securities have been received by the Issuer, cryptocurrency is sent to AP</span></span></span>"],
        [485, 0, 1 - 0.05, "<span class='d-flex'><span class='step__number orange'>4</span><span class='d-flex flex-column'><span class='step__name'>Primary Market</span><span class='step__dscr'>The independent transaction administrator verifies the redemption order and confirms that the required amounts and corresponding crypto balances are in place to process the trade.<br><br>Only after ETP securities have been received by the Issuer, cryptocurrency is sent to AP</span></span></span>"],
        [570, 0, 1 - 0.05, "<span class='d-flex'><span class='step__number orange'>4</span><span class='d-flex flex-column'><span class='step__name'>Primary Market</span><span class='step__dscr'>Only after ETP securities have been received by the Issuer, cryptocurrency is sent to AP</span></span></span>"],
        [800, 0, 1 - 0.05, "<span class='d-flex'><span class='step__number light-blue'>5</span><span class='d-flex flex-column'><span class='step__name'>Secondary Market</span><span class='step__dscr'>AP settles cash with broker and investor receives cash</span></span></span>"],
    ];
    let stopFrame = 0;
    let stopFrame1 = 0;
    let reportFrame = { on: false };

    const cframe = document.querySelector('.js-frame');
    const player = document.querySelector('.lottie__buy');
    const player1 = document.querySelector('.lottie__sell');
    const rect = player.getBoundingClientRect();
    const offset = [
        rect.left + document.scrollingElement.scrollLeft,
        rect.top + document.scrollingElement.scrollTop,
    ];
    const rect1 = player1.getBoundingClientRect();
    const offset1 = [
        rect1.left + document.scrollingElement.scrollLeft,
        rect1.top + document.scrollingElement.scrollTop,
    ];


    const showAlert = (num) => {

        player.addEventListener('stop', event => { num = 0 })

        const alert = stopOnFrames[num];

        // slick 
        switch (num) {
            case 1:
                $('#anim-slick__buy').removeClass('bottom')
                $('#anim-slick__buy').removeClass('center')
                $('#anim-slick__buy').addClass('left')
                break;
            case 3:
                $('#anim-slick__buy').removeClass('left')
                $('#anim-slick__buy').addClass('center')
                break;
            case 5:
                $('#anim-slick__buy').removeClass('center')
                $('#anim-slick__buy').addClass('bottom')
                break;
            default:
                break;
        }
        if (num > 0 && num > $('#anim-slick__buy').slick('slickCurrentSlide')) {
            $('#anim-slick__buy').slick('slickNext');
        }
        else if (num == 0) {
            $('#anim-slick__buy').slick('slickGoTo', 0, true);
        }
        if (num != $('#anim-slick__buy').slick('slickCurrentSlide')) {
            $('#anim-slick__buy').slick('slickGoTo', num, true);
        }
        $('#anim-slick__buy').height($('#anim-slick__buy .slick-slide.slick-current').height());

    };
    const showAlert1 = (num) => {

        player1.addEventListener('stop', event => { num = 0 })

        const alert1 = stopOnFrames1[num];
        switch (num) {
            case 1:
                $('#anim-slick__sell').removeClass('bottom')
                $('#anim-slick__sell').removeClass('center')
                $('#anim-slick__sell').addClass('left')
                break;
            case 3:
                $('#anim-slick__sell').removeClass('left')
                $('#anim-slick__sell').addClass('center')
                break;
            case 5:
                $('#anim-slick__sell').removeClass('center')
                $('#anim-slick__sell').addClass('bottom')
                break;
            default:
                break;
        }
        if (num > 0 && num > $('#anim-slick__sell').slick('slickCurrentSlide')) {
            $('#anim-slick__sell').slick('slickNext');
        } else if (num == 0) {
            $('#anim-slick__sell').slick('slickGoTo', 0, true);
        }
        if (num != $('#anim-slick__sell').slick('slickCurrentSlide')) {
            $('#anim-slick__sell').slick('slickGoTo', num, true);
        }
        $('#anim-slick__sell').height($('#anim-slick__sell .slick-slide.slick-current').height());
    };
    player.addEventListener('frame', event => {
        const frame22 = Math.round(event.detail.frame);
        if (frame22 > 1 && frame22 < 3) {
            showAlert(1);
            stopFrame = 1;
        }
        if (frame22 > 0 && frame22 < 70) {
            player.setSpeed(0.7);
        }
        else if (frame22 >= 71 && frame22 <= 104) {
            player.setSpeed(0.5);
        }
        else if (frame22 >= 105 && frame22 <= 148) {
            player.setSpeed(0.7);
        }
        else if (frame22 >= 149 && frame22 <= 190) {
            player.setSpeed(0.5);
        }
        else if (frame22 >= 191 && frame22 <= 248) {
            player.setSpeed(0.7);
        }
        else if (frame22 >= 249 && frame22 <= 279) {
            player.setSpeed(0.5);
        }
        else if (frame22 >= 280 && frame22 <= 340) {
            player.setSpeed(0.7);
        }
        else if (frame22 >= 341 && frame22 <= 374) {
            player.setSpeed(0.5);
        }
        else if (frame22 >= 375 && frame22 <= 435) {
            player.setSpeed(0.7);
        }
        else if (frame22 >= 436 && frame22 <= 474) {
            player.setSpeed(0.5);
        }
        else if (frame22 >= 475 && frame22 <= 530) {
            player.setSpeed(0.7);
        }
        else if (frame22 >= 531 && frame22 <= 565) {
            player.setSpeed(0.5);
        }
        else if (frame22 >= 566 && frame22 <= 625) {
            player.setSpeed(0.7);
        }
        else if (frame22 >= 626 && frame22 <= 690) {
            player.setSpeed(0.5);
        }
        else if (frame22 >= 691 && frame22 <= 707) {
            player.setSpeed(0.7)
        }
        else if (frame22 >= 708 && frame22 <= 737) {
            player.setSpeed(0.5);
        }
        else if (frame22 >= 738 && frame22 <= 780) {
            player.setSpeed(0.5);
        }
        else if (frame22 >= 781 && frame22 <= 818) {
            player.setSpeed(0.7);
        }
        else {
            player.setSpeed(0.7);
        }
    });
    player1.addEventListener('frame', event => {
        const frame22 = Math.round(event.detail.frame);
        if (frame22 > 1 && frame22 < 3) {
            showAlert1(1);
            stopFrame1 = 1;
        }
        if (frame22 > 0 && frame22 < 78) {
            player1.setSpeed(0.7);
        }
        else if (frame22 >= 79 && frame22 <= 104) {
            player1.setSpeed(0.5);
        }
        else if (frame22 >= 105 && frame22 <= 148) {
            player1.setSpeed(0.7);
        }
        else if (frame22 >= 149 && frame22 <= 187) {
            player1.setSpeed(0.5);
        }
        else if (frame22 >= 188 && frame22 <= 248) {
            player1.setSpeed(0.7);
        }
        else if (frame22 >= 249 && frame22 <= 267) {
            player1.setSpeed(0.5);
        }
        else if (frame22 >= 267 && frame22 <= 300) {
            player1.setSpeed(0.7);
        }
        else if (frame22 >= 301 && frame22 <= 333) {
            player1.setSpeed(0.5);
        }
        else if (frame22 >= 334 && frame22 <= 400) {
            player1.setSpeed(0.7);
        }
        else if (frame22 >= 401 && frame22 <= 450) {
            player1.setSpeed(0.5);
        }
        else if (frame22 >= 451 && frame22 <= 487) {
            player1.setSpeed(0.7);
        }
        else if (frame22 >= 488 && frame22 <= 530) {
            player1.setSpeed(0.5);
        }
        else if (frame22 >= 531 && frame22 <= 568) {
            player1.setSpeed(0.7);
        }
        else if (frame22 >= 569 && frame22 <= 637) {
            player1.setSpeed(0.7);
        }
        else if (frame22 >= 638 && frame22 <= 670) {
            player1.setSpeed(0.7)
        }
        else if (frame22 >= 671 && frame22 <= 725) {
            player1.setSpeed(0.7);
        }
        else if (frame22 >= 726 && frame22 <= 756) {
            player1.setSpeed(0.7)
        }
        else if (frame22 >= 757 && frame22 <= 818) {
            player1.setSpeed(0.7);
        }
        else {
            player1.setSpeed(0.7);
        }
    });
    $(document).ready(() => {
        player.play();
        $('#anim-slick__buy').slick({
            centerMode: true,
            slidesToShow: 1,
            swipe: false,
            arrows: false,
            infinite: false,
        });
        $('#anim-slick__sell').slick({
            centerMode: true,
            slidesToShow: 1,
            swipe: false,
            arrows: false,
            infinite: false,
        });

        let activeClass = 'bw btn btn-dark btn-md active';
        let incativeClass = 'bw btn btn-outlined btn-grey btn-md';

        $("#pills-buy-order-tab").click(function () {
            $('#anim-slick__sell').addClass('slider-hidden')
            $('#anim-slick__buy').removeClass('slider-hidden')
            player1.stop();
            player.play();
            stopFrame = 0;
            $('#animControl').attr('data-controlls', 'buy');
            $('#animControl').html('<img src="/products/how_it_works/img/pause.svg" alt="pause">');

            $(this).on('shown.bs.tab', function(e){
                $(e.target).closest('.toggles__buttons').find('[data-toggle="tab"]').each(function() {$(this).attr('class', incativeClass)});
                $(this).attr('class', activeClass);
            })

        });
        $("#pills-sell-order-tab").click(function () {
            $('#anim-slick__buy').addClass('slider-hidden')
            $('#anim-slick__sell').removeClass('slider-hidden')
            player.stop();
            player1.play();
            stopFrame = 0;
            $('#animControl').attr('data-controlls', 'sell');
            $('#animControl').html('<img src="/products/how_it_works/img/pause.svg" alt="pause">');

            $(this).on('shown.bs.tab', function(e){
                $(e.target).closest('.toggles__buttons').find('[data-toggle="tab"]').each(function() {$(this).attr('class', incativeClass)});
                $(this).attr('class', activeClass);
            })
        });
    });

    $('#animControl').click(function(){
        let action = $(this).attr('data-action');
        let controlls = $(this).attr('data-controlls');

        let anim = controlls == 'buy' ?  player : player1;

        switch (action) {
            case 'play': 
                anim.play();
                $(this).html('<img src="/products/how_it_works/img/pause.svg" alt="pause">');
                $(this).attr('data-action','pause');
                reportFrame.on = true;
            break;
            case 'pause': 
                anim.pause();
                $(this).html('<img src="/products/how_it_works/img/play.svg" alt="play">');
                $(this).attr('data-action','play');
                reportFrame.on = false;
            break;
        };
    });

    player.addEventListener('frame', event => {
        const frame = Math.round(event.detail.frame);
        if (reportFrame.on) {
            reportFrame.on = false;
            console.log(`${frame}, ${reportFrame.left}, ${reportFrame.top}`);
            player.pause();
            setTimeout(() => player.play(), 100);
        }
        if (
            stopOnFrames[stopFrame] && (frame > stopOnFrames[stopFrame][0])
        ) {
            showAlert(stopFrame);
            // console.log(stopFrame);
            stopFrame += 1;
        }
    });
    player1.addEventListener('frame', event => {
        const frame = Math.round(event.detail.frame);
        if (reportFrame.on) {
            reportFrame.on = false;
            console.log(`${frame}, ${reportFrame.left}, ${reportFrame.top}`);
            player.pause();
            setTimeout(() => player.play(), 100);
        }
        if (
            stopOnFrames1[stopFrame] && (frame > stopOnFrames1[stopFrame][0])
        ) {
            showAlert1(stopFrame);
            stopFrame += 1;
        }
    });
})();